export default __webpack_public_path__ + "static/media/explore-mobile-7.63f8e4a7.png";